import { render } from "./RunFirst.vue?vue&type=template&id=cc421700"
import script from "./RunFirst.vue?vue&type=script&lang=js"
export * from "./RunFirst.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\galita-api\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__